import { Box, Tooltip, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InfoSvg from "../../images/info.svg";

export function Card({ title, subtitle, info = null, tooltip = null, action = null, headerMargin, ...props }) {
  return (
    <Box
      {...props}
      sx={{
        borderRadius: 3,
        border: (theme) => "1px solid " + theme.palette.background.border,
        padding: 2,
        backgroundColor: "white",
        ...props.sx,
      }}
    >
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={headerMargin != null ? headerMargin : subtitle ? 1 : 3}
      >
        {title && (
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5, mb: 0.5 }}>
            <Typography
              fontWeight={700}
              fontSize={20}
              noWrap
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flexGrow: 1,
              }}
            >
              {title}
            </Typography>
            {info && (
              <Tooltip title={info}>
                <img width={15} src={InfoSvg} alt="Info button" />
              </Tooltip>
            )}
          </Box>
        )}
        {action}
        {tooltip != null && (
          <Tooltip title={tooltip}>
            <InfoOutlinedIcon sx={{ ml: 1, cursor: "pointer", opacity: 0.2 }} />
          </Tooltip>
        )}
      </Box>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ pb: 2 }}>
          {subtitle}
        </Typography>
      )}

      {props.children}
    </Box>
  );
}
